import { motion } from 'framer-motion';
import React from 'react';
import { FiFacebook, FiInstagram, FiLinkedin, FiMail, FiMapPin, FiPhone, FiTwitter } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Footer = () => {
  const services = [
    "IT Staffing",
    "Project Services", 
    "Project Management",
    "Enterprise Applications",
    "Cloud & Infrastructure",
    "Business Process Management",
    "Business Transformation",
    "AI & Intelligent Agent Development",
    "Cyber Security"
  ];

  const quickLinks = [
    { name: "About Us", href: "/about" },
    { name: "Our Services", href: "/services" },
    { name: "Our Expertise", href: "/expertise" },
    { name: "Careers", href: "#careers" },
    { name: "Contact", href: "/contact" },
    { name: "Blog", href: "/blogs" }
  ];

  const socialLinks = [
    { icon: FiLinkedin, href: "https://www.linkedin.com/company/innofusion-analytics-llc/", label: "LinkedIn" },
    { icon: FiTwitter, href: "https://x.com/InnoFusion_IFA?t=TX41SiD-OrpOH4xF2pkfmA&s=09", label: "Twitter" },
    { icon: FiInstagram, href: "https://www.instagram.com/innofusionanalytics?utm_source=qr&igsh=MWkyZTdwaXd5azQyeg== ", label: "Instagram" },
    { icon: FiFacebook, href: "https://www.facebook.com/innofusionanalytics", label: "Facebook" }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid-white/[0.02] bg-[size:50px_50px]"></div>
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-blue-500/10 rounded-full filter blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-indigo-500/10 rounded-full filter blur-3xl animate-pulse animation-delay-2000"></div>

      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
            {/* Company Info */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="lg:col-span-1"
            >
              <div className="flex items-center space-x-2 mb-6">
                <div className="w-10 h-10  rounded-lg flex items-center justify-center">
                <img src="./Innofusion.png" alt="InnoFusion Logo" className="w-10 h-10 rounded-full" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent font-display tracking-tight">
                    InnoFusion
                  </h2>
                  <p className="text-xs text-gray-400 -mt-1 font-body tracking-wide">Analytics</p>
                </div>
              </div>
              
              <p className="text-gray-300 mb-6 font-body leading-relaxed">
                Transforming businesses with expert talent and innovative solutions. 
                We connect you with top-tier professionals to accelerate your digital transformation journey.
              </p>

              <div className="space-y-3">
                <div className="flex items-center space-x-3 text-gray-300">
                  <FiMapPin className="text-blue-400" size={18} />
                  <span className="font-body text-sm">United States</span>
                </div>
               
                <div className="flex items-center space-x-3 text-gray-300">
                  <FiMail className="text-blue-400" size={18} />
                  <span className="font-body text-sm">Connect@innofusionanalytics.com </span>
                </div>
                
              </div>
            </motion.div>

            {/* Services */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold text-white mb-6 font-heading tracking-wide">Our Services</h3>
              <ul className="space-y-3">
                {services.slice(0, 6).map((service, index) => (
                  <li key={index}>
                    <a
                      href="#"
                      className="text-gray-300 hover:text-blue-400 transition-colors duration-300 text-sm font-body block"
                    >
                      {service}
                    </a>
                  </li>
                ))}
                <li>
                  <a
                    href="#"
                    className="text-blue-400 hover:text-blue-300 transition-colors duration-300 text-sm font-body inline-flex items-center space-x-1"
                  >
                    <span>View All Services</span>
                    <span>→</span>
                  </a>
                </li>
              </ul>
            </motion.div>

            {/* Quick Links */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold text-white mb-6 font-heading tracking-wide">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    {link.href.startsWith('/') ? (
                      <Link
                        to={link.href}
                        className="text-gray-300 hover:text-blue-400 transition-colors duration-300 text-sm font-body block"
                      >
                        {link.name}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-gray-300 hover:text-blue-400 transition-colors duration-300 text-sm font-body block"
                      >
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>

              <div className="mt-8">
                <h4 className="text-lg font-semibold text-white mb-4 font-heading tracking-wide">Newsletter</h4>
                <p className="text-gray-300 text-sm mb-4 font-body">
                  Subscribe to get the latest insights and updates.
                </p>
                <div className="flex">
                 
                </div>
              </div>
            </motion.div>

            {/* Contact & Social */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold text-white mb-6 font-heading tracking-wide">Connect With Us</h3>
              
              <div className="grid grid-cols-2 gap-3 mb-8">
                {socialLinks.map((social, index) => (
                  <motion.a
                    key={index}
                    href={social.href}
                    whileHover={{ scale: 1.05 }}
                    className="flex items-center space-x-2 p-3 bg-white/5 rounded-lg border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300 group"
                  >
                    <social.icon className="text-blue-400 group-hover:text-blue-300" size={18} />
                    <span className="text-gray-300 group-hover:text-white text-sm font-body">{social.label}</span>
                  </motion.a>
                ))}
              </div>

              <div className="bg-gradient-to-br from-blue-600/20 to-indigo-700/20 p-6 rounded-xl border border-blue-500/20">
                <h4 className="text-lg font-semibold text-white mb-3 font-heading tracking-wide">Get Started Today</h4>
                <p className="text-gray-300 text-sm mb-4 font-body">
                  Ready to transform your business? Contact us for a free consultation.
                </p>
                <Link
                  to="/contact"
                  className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-indigo-700 text-white px-4 py-2 rounded-lg hover:from-blue-700 hover:to-indigo-800 transition-all duration-300 font-accent text-sm tracking-wide"
                >
                  <span>Contact Us</span>
                  <span>→</span>
                </Link>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-gray-400 text-sm font-body">
                © 2025 Innofusion Analytics, LLC. All rights reserved. Built with precision and passion.
              </div>
              <div className="flex items-center space-x-6 text-sm">
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors duration-300 font-body">
                  Privacy Policy
                </Link>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors duration-300 font-body">
                  Terms of Service
                </Link>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 